import {
  DEFAULT_LANGUAGE,
  languageMap,
  availableLanguages,
} from "../i18n/languages";

const getLocale = (lang) => {
  const language = availableLanguages.includes(lang) ? lang : DEFAULT_LANGUAGE;
  return languageMap[language];
};

export { getLocale };
